module.exports = __webpack_public_path__ + "img/severPage_icon.1279503c.png";